import type { FunctionComponent, SVGProps } from 'react';
import PixelHand from '@/assets/images/2-pixel-hand.svg?react';
import CardAccountant from '@/assets/images/2-target-your-mate-card-accountant.jpg';
import CardBoss from '@/assets/images/2-target-your-mate-card-boss.jpg';
import CardDesigner from '@/assets/images/2-target-your-mate-card-designer.jpg';
import CardSalesman from '@/assets/images/2-target-your-mate-card-salesman.jpg';

export const HANDS_FOR_ANIMATION: FunctionComponent<SVGProps<SVGSVGElement>>[] = [PixelHand, PixelHand, PixelHand, PixelHand, PixelHand, PixelHand];
export const HAND_CSS_SELECTOR_PREFIX = 'pixel-hand';
export const HAND_ANIMATION_FADING_MILLISECONDS = 2000;
export const HAND_ANIMATION_DELAY_BETWEEN_MILLISECONDS = 500;

/**
 * 4 pairs = 8 cards total
 */
export const CARDS_FRONTS = [CardAccountant, CardBoss, CardDesigner, CardSalesman];

/**
 * Index of the pair that should be selected for validation (0-3)
 */
export const CORRECT_PAIR_INDEX = 3;

/**
 * 1 second
 */
export const FLIP_BACK_DELAY = 1000;
